function subscribe(match, handler) {
  if (match.addListener) {
    match.addListener(handler)
  } else {
    match.addEventListener('change', handler)
  }
}

export function matchMedia(media) {
  const match = window.matchMedia(media)
  return function (handler) {
    return subscribe(match, handler)
  }
}
